import { Injectable, inject } from '@angular/core';
import { map, shareReplay, switchMap } from 'rxjs';

import { GroupsService } from './groups.service';

@Injectable({
  providedIn: 'root',
})
export class UIGroupsService {
  private readonly groupsService = inject(GroupsService);

  readonly allGroupsMap$ = this.groupsService.refresh$.pipe(
    switchMap(() =>
      this.groupsService
        .listGroups({ limit: 1000, offset: 0 })
        .pipe(map(({ items }) => new Map(items.map((i) => [i.id, i])))),
    ),
    shareReplay({ refCount: true, bufferSize: 1 }),
  );
}
